module.exports = __webpack_public_path__ + "static/media/homepage_3.e4fb2cd2.jpg";